const AgentTimezoneOptions = (list) => {
  const options = [];

  for (let i = -12; i <= 12; i++) {
    let iname = "" + i;
    if (i >= 0) iname = "+" + i;
    options.push({
      key: "Etc/GMT" + iname,
      title: "GMT" + iname,
      value: "Etc/GMT" + iname,
    });
  }

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default AgentTimezoneOptions;
